<template lang="pug">
  #ourservices
    .content
      h2.section-title Nossos #[strong Serviços]
      .services
        .service(v-for="service in services")
          .icon(:style="{ 'mask-image' : `url(${service.icon})` }")
          h4.title {{ service.title }}
          p.description {{ service.description }}
</template>

<script>
export default {
  name: 'OurServices',
  data: () => ({
    services: [
      {
        icon: require('../assets/icons/car-repair.svg'),
        title: 'Alinhamento',
        description: 'O alinhamento do seu veículo pode ficar comprometido por causa do choque do pneu com uma calçada, buracos nas pistas ou mesmo em acidentes mais graves como uma batida. Quando o veículo está desalinhado, as bordas (ombros) dos pneus se desgastam mais rapidamente, comprometendo o desempenho do veículo.',
      },
      {
        icon: require('../assets/icons/tires.svg'),
        title: 'Balanceamento',
        description: 'O conserto feito em rodas de liga leve quando amassadas serve para manter o balanceamento perfeito das rodas. As rodas de liga leve são construídas com a finalidade de absorver impactos, que causam a deformação da mesma.',
      },
      {
        icon: require('../assets/icons/motor.svg'),
        title: 'Revisão Geral',
        description: 'O objetivo desse trabalho é evitar, por exemplo, a quebra de um componente ou mesmo a parada total do veículo no meio da rua. Como você pode imaginar, o risco de acidentes é grande quando não se faz a manutenção preventiva do automóvel. Por isso, a revisão do carro é feita para antecipar eventuais problemas nos diferentes sistemas do veículo e, com isso, deixá-lo em ótimas condições de uso.',
      },
      {
        icon: require('../assets/icons/suspension.svg'),
        title: 'Suspensão',
        description: 'Buracos e irregularidades deslocam os pontos de fixação da posição inicial do sistema de suspensão, fazendo o carro perder conforto, dirigibilidade e segurança. Como a fixação é toda realizada por meio de parafusos ajustáveis, recomenda-se fazer com frequência a regulagem desses pontos. Este processo, chamado de geometria de suspensão, deixa as quatro rodas novamente centralizadas, formando um retângulo.',
      },
      {
        icon: require('../assets/icons/spark.svg'),
        title: 'Injeção Eletrônica',
        description: 'Para o carro andar é preciso que a mistura de ar e combustível. A injeção eletrônica é responsável por esse controle. ... A injeção eletrônica é o sistema que controla o ar e o combustível que entram no motor do carro ou qualquer veículo que se utilize desta tecnologia.',
      },
      {
        icon: require('../assets/icons/car-oil.svg'),
        title: 'Troca de Óleo',
        description: 'Nunca é demais lembrar que o óleo, além de lubrificar, limpa as superfícies internas do motor e garante seu bom desempenho. Mesmo assim, tem gente que comete erros comuns ao trocar o produto.',
      }
    ]
  })
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#ourservices
  float left
  width 100%
  height 100%
  display flex
  justify-content center

  .content
    width 1366px

    .services
      display flex
      flex-wrap wrap
      align-items center
      float left
      width 100%
      height 80%

      .service
        width 33%
        display flex
        flex-direction column
        align-items center
        padding 0 25px
        box-sizing border-box

        .icon
          width 50px
          height 50px
          mask-size contain
          mask-position center
          mask-repeat no-repeat
          background-color $revisacar-red

        .title
          color black
          font-size 16px
          font-weight 900
          margin-bottom 5px
          text-transform uppercase

        .description
          color #999999
          font-size 14px

@media (max-width: 1366px)
  #ourservices
    height auto

    .content
      width 100%

      .services

        .service
          width 50%
</style>



// WEBPACK FOOTER //
// src/components/OurServices.vue